export const COMMENTS_CONTEXT_SOCIAL_FEED = 'socialFeed';
export const COMMENTS_DESIGN_STUDIO_TOGGLE_EVENT = 'DesignStudioToggleComment';
export const COMMENTS_DESIGN_STUDIO_SELECT_COMMUNITY =
  'DesignStudioSelectCommunity';
export default {
  COMMENTS_CONTEXT_SOCIAL_FEED,
  COMMENTS_DESIGN_STUDIO_TOGGLE_EVENT,
  COMMENTS_DESIGN_STUDIO_SELECT_COMMUNITY
};
